/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ErasureStatus {
    NOT_STARTED = 'NotStarted',
    IN_PROGRESS = 'InProgress',
    COMPLETED = 'Completed',
    BLOCKED = 'Blocked',
}
